<head>
<script src="https://unpkg.com/vue"></script>
</head>
<template>
  <a-card title="Cadastro de Setor">
    <form ref="form" @submit.prevent="submitForm">
      <div class="row">
        <div class="col-md-8">
          <label for="nome">Setor</label><label style="margin-left: 1px; font-weight: bold; color: red">*</label>
          <br />
          <input v-model="registro.nome" type="text" class="ant-input ant-input-lg" required v-bind:class="{ 'is-invalid': submitted && !registro.unidadeAtendimento }" />
        </div>
      </div>
      <br />
      <div class="row">
        <div class="col-md-8">
          <label>Unidade de Atendimento</label><label style="margin-left: 1px; font-weight: bold; color: red">*</label>
          <br />
          <div class="input-group input-focus">
            <select v-model="registro.unidadeAtendimento" class="ant-input ant-input-lg" style="margin: 0; height: 40px" required v-bind:class="{ 'is-invalid': submitted && !registro.unidadeAtendimento }">
              <option value=""></option>
              <option v-for="item in unidadesAtendimento" :key="item.id" :value="item">
                {{ item.descricao }}
                <!-- ou o campo que representa o texto -->
              </option>
            </select>
          </div>
        </div>
      </div>

      <br />
      <div class="row" v-show="itensSelecionados.length > 0">
        <div class="col-md-8">
          <a-table :dataSource="itensSelecionados" :columns="columns">
            <template #action="{ record }">
              <a title="Opções" @click="removerItem(record)"><i class="fas fa-trash icon-trash"></i></a>
              &nbsp;
            </template>
          </a-table>
        </div>
      </div>
      <div class="row">
        <div class="col-4">
          <label for="status">Status</label><label style="margin-left: 1px; font-weight: bold; color: red">*</label>

          <div class="input-group input-focus">
            <select v-model="registro.situacao" class="ant-input ant-input-lg" style="margin: 0; height: 40px" required v-bind:class="{ 'is-invalid': submitted && !registro.unidadeAtendimento }">
              <option value="ATIVO">Ativo</option>
              <option value="INATIVO">Inativo</option>
            </select>
          </div>
        </div>
      </div>
      <a-divider type="horizontal" />
      <div class="row">
        <div class="spaced-container">
          <button type="submit" class="btn btn-primary" @click="cadastrar">Salvar</button>
          <button class="btn btn-warning" @click="voltar">Voltar</button>
        </div>
      </div>
    </form>
  </a-card>
</template>

<script>
import { openNotification, typesNotification } from '@/utils/notifications';
import { create, getById } from '@/components/service/setorService';
import { getUnidadeAtendimento } from '@/config/servicos-utils';
export default {
  name: 'FormManterDepartamento',
  setup() {
    return {};
  },
  data() {
    return {
      nomePagina: 'Setor',
      unidadesAtendimento: [],
      submitted: false,
      selecionar: { id: null, nome: null },
      itensSelecionados: [],
      registro: {},
      columns: [
        {
          title: 'Nome',
          dataIndex: 'nome',
          key: 'nome',
          slots: { customRender: 'nome' },
        },

        {
          title: 'Ações',
          dataIndex: 'action',
          key: 'action',
          slots: { customRender: 'action' },
        },
      ],
    };
  },
  methods: {
    async cadastrar() {
      //this.v$.$validate()
      this.submitted = true;
      if (!this.$refs.form.checkValidity()) {
        openNotification(typesNotification.warning, 'Informe os campos obrigatórios!');
      } else {
        let registroPost = { ...this.registro };

        await create(registroPost).then(() => {
          //let retorno = r.data;
          if (!this.registro.id) {
            openNotification(typesNotification.success, 'Dados salvos com sucesso.');
          } else {
            openNotification(typesNotification.success, 'Dados alterados com sucesso.');
          }
          this.itensSelecionados = [];
          this.submitted = false;
          this.registro = {};
        });
      }
    },

    onSelect(value) {
      if (value.descricao) {
        this.registro.unidadeAtendimento = { id: value.id, descricao: value.descricao };
      }
      this.registro.unidadeAtendimento = { id: null, descricao: null };
    },

    async carregarUnidadesAtendimento() {
      await getUnidadeAtendimento().then((response) => {
        this.unidadesAtendimento = response.data;
      });
    },
    voltar() {
      this.$router.go(-1);
    },
    async carregar() {
      if (this.$route.query.id) {
        const idUrl = this.$route.query.id;
        const res = await getById(idUrl);
        this.registro = { ...res.data, id: idUrl };
        if (this.registro.departamentos) {
          this.itensSelecionados = [...this.registro.departamentos];
        }
      }
    },
  },
  async created() {
    this.carregar();
    this.carregarUnidadesAtendimento();
  },
};
</script>

<style>
.input-group-text {
  height: 38px;
}

.input-group-prepend {
  cursor: pointer;
  margin-left: 8px !important;
}

.input-group-text:hover {
  background-color: #e0e0e0 !important;
}

.h2 {
  font-size: x-large;
}

.spaced-container * {
  margin-top: 10px;
  margin-right: 10px;
}
</style>
